import React from "react";
import { Form, Modal, Button, Row, Col } from "react-bootstrap";
import { StyleSheet, css } from "aphrodite";
import { callApi, validateToken } from "../../lib/utils";
import VerificationInput from "react-verification-input";
import CustomLoader from "../GenericComponents/CustomLoader";
//import styles from "../../../public/";
import styles from "./style";

class VerifyEmailModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            verificationCode: "",
            failureMessage: "",
            successMessage: "",
            loading: false
        };
    }

    handleChange = (data) => {
        this.setState({
            verificationCode: data
        })
    }

    handleClose = () => {
        this.setState(
            {
                verificationCode: "",
                failureMessage: "",
                successMessage: "",
            },
            () => {
                this.props.close();
            }
        );
    };

    submit = () => {
        validateToken((err) => {
            if (err) {
                window.location = "/logout";
            }
            let params = {
                verificationToken: this.props.token,
                code: this.state.verificationCode,
            };
            this.setState({
                loading: true,
            });
            callApi(`/api/patient/web/email-change/verify`, params, "POST")
                .then((response) => {
                    if (response.status === 204) {
                        this.setState(
                            {
                                successMessage: "Email Changed Successfully",
                                failureMessage: "",
                                loading: false,
                            },
                            () => {
                                this.props.handleSuccessModal(this.state.successMessage);
                            }
                        );
                    } else {
                        this.setState({
                            failureMessage: response.data.message,
                            loading: false,
                        });
                    }
                })
                .catch((err) => {
                    console.log("err: ", err);
                    this.setState({
                        failureMessage: err.message,
                        loading: false,
                    });
                });
        });
    };

    render() {
        const { show, title, profileData, newEmailId } = this.props;

        return (
            <div>
                <CustomLoader loading={this.state.loading} />

                <Modal
                    size="md"
                    show={show}
                    onHide={this.handleClose}
                    centered={true}
                    backdrop="static"
                    keyboard={false}
                >
                    <Modal.Header className={css(styles.headerStyle)}>
                        <Modal.Title>
                            <div className={css(styles.title)}>{title}</div>
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div>
                            {this.state.failureMessage && (
                                <div
                                    style={{
                                        backgroundColor: "white",
                                        color: "red",
                                        textAlign: "center",
                                    }}
                                >
                                    {this.state.failureMessage}
                                </div>
                            )}
                            {/* {this.state.successMessage && (
                 <div
                   style={{
                     backgroundColor: "white",
                     color: "green",
                     textAlign: "center",
                   }}
                 >
                   {this.state.successMessage}
                 </div>
               )} */}
                            <p style={{ fontSize: "16px" }}>Enter verification code sent to <b>{newEmailId}</b></p>
                            <VerificationInput placeholder="_" validChars="0-9" inputProps={{ inputMode: "numeric" }} onComplete={this.handleChange} />

                        </div>
                    </Modal.Body>
                    <Modal.Footer className={css(styles.footerStyle)}>
                        <Button variant="primary" onClick={() => this.submit()}>
                            Verify
                        </Button>
                    </Modal.Footer>
                </Modal>
            </div>
        );
    }
}

export default VerifyEmailModal;

